"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Background = exports.Content = exports.Header = exports.Wrapper = exports.GlobalStyle = void 0;
// Modules
const styled_components_1 = __importStar(require("styled-components"));
// Helpers
const utils_1 = require("../../utils");
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  ${({ showModal }) => `
  ${showModal
    ? `
        #global-footer {
          display: none;
        }
        `
    : ''}
  `}
`;
exports.Wrapper = styled_components_1.default.div `
  ${({ theme, closingModal }) => `
    width: 100%;
    background: ${theme.colors.build.light.default};
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    z-index: 99999;
    box-shadow: 0px -8px 48px rgba(0, 0, 0, 0.25);
    border-radius: 16px 16px 0px 0px;
    max-height: 100vh;
    overflow: hidden;

    ${utils_1.isMobile.iOS() ? 'max-height: 80vh;' : ''}

    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, .5);
      box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }

    ${closingModal
    ? `
        @keyframes hideModal {
          from {
            bottom: 0px;
            opacity: 1;
          }
          to {
            bottom: -50px;
            opacity: 0;
          }
        }
        animation-name: hideModal;
        animation-duration: 0.3s;`
    : `

        @keyframes showModal {
          from {
            bottom: -50px;
            opacity: 0;
          }
          to {
            bottom: 0;
            opacity: 1;
          }
        }
        animation-name: showModal;
        animation-duration: 0.3s;
    `}

    ${!utils_1.isMobile.any()
    ? `
        width: 560px;
        left: 50%;
        transform: translate(-50%, 0);
        `
    : ''}
  `}
`;
exports.Header = styled_components_1.default.div `
  ${({ theme }) => `
    width: 100%;
    margin-bottom: ${theme.spaces.sp4};
    padding: ${theme.spaces.sp5};
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F5F5F5;

    h1 {
      margin: 0 ${theme.spaces.sp4} 0 0;
      ${theme.type.bodyMediumShort}
    }

    p {
      margin-bottom:0 ;
      ${theme.type.bodyMediumShort}
      color: ${theme.colors.build.dark.light};
    }
    svg {
      font-size: 24px;
      fill: ${theme.colors.build.dark.default};
      cursor: pointer;
    }
  `}
`;
exports.Content = styled_components_1.default.div `
  ${({ theme }) => `
    width: 100%;
    padding: 0 ${theme.spaces.sp5} ${theme.spaces.sp5};
    .modal-content > div {
      justify-content: flex-start;
    }
  `}
`;
exports.Background = styled_components_1.default.div `
  ${({ theme }) => `
    background: ${theme.colors.build.dark.default};
    height: 100%;
    left: 0;
    opacity: 0.64;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
  `}
`;
